document.addEventListener('DOMContentLoaded', () => {
  const form = document.getElementById('FooterContactForm');

  if (!form) return;

  const requiredFields = form.querySelectorAll('[data-required-message]');

  requiredFields.forEach((field) => {
    field.addEventListener('invalid', () => {
      field.setCustomValidity('');

      if (field.validity.valueMissing) {
        field.setCustomValidity(field.dataset.requiredMessage);
      } else if (field.validity.typeMismatch && field.dataset.invalidEmailMessage) {
        field.setCustomValidity(field.dataset.invalidEmailMessage);
      }
    });

    field.addEventListener('input', () => {
      field.setCustomValidity('');
    });
  });
});
